import type { SocialAuthType } from '../../utils/social';
import apple from './apple';
import discord from './discord';
import email from './email';
import facebook from './facebook';
import github from './github';
import google from './google';
import linkedin from './linkedIn';
import microsoft from './microsoft';
import passkeySmartWallet from './passkey';
import phone from './phone';
import twitch from './twitch';
import twitter from './twitter';

export const socialIcons = {
  apple,
  discord,
  facebook,
  github,
  google,
  linkedin,
  microsoft,
  twitch,
  twitter,
  email,
  phone,
  passkeySmartWallet,
};

export default function getSocialIcon(authType: SocialAuthType | 'passkeySmartWallet') {
  return socialIcons[authType];
}
